var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{staticClass:"dropdown-item dropdown-sub-item d-flex align-items-center",on:{"click":function($event){return _vm.$openTab({ label: _vm.tabLabel, link: _vm.link })}}},[_c('feather-icon',{attrs:{"type":_vm.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }